var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 21.5C23.7044 21.5 22.9413 21.8161 22.3787 22.3787C21.8161 22.9413 21.5 23.7044 21.5 24.5C21.5 25.2956 21.8161 26.0587 22.3787 26.6213C22.9413 27.1839 23.7044 27.5 24.5 27.5C25.2956 27.5 26.0587 27.1839 26.6213 26.6213C27.1839 26.0587 27.5 25.2956 27.5 24.5C27.5 23.7044 27.1839 22.9413 26.6213 22.3787C26.0587 21.8161 25.2956 21.5 24.5 21.5Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 6.5C22.1362 6.5 19.7956 6.96558 17.6117 7.87017C15.4278 8.77475 13.4435 10.1006 11.7721 11.7721C10.1006 13.4435 8.77475 15.4278 7.87017 17.6117C6.96558 19.7956 6.5 22.1362 6.5 24.5C6.5 26.8638 6.96558 29.2044 7.87017 31.3883C8.77475 33.5722 10.1006 35.5565 11.7721 37.2279C13.4435 38.8994 15.4278 40.2252 17.6117 41.1298C19.7956 42.0344 22.1362 42.5 24.5 42.5C26.8638 42.5 29.2044 42.0344 31.3883 41.1298C33.5722 40.2252 35.5565 38.8994 37.2279 37.2279C38.8994 35.5565 40.2252 33.5722 41.1298 31.3883C42.0344 29.2044 42.5 26.8638 42.5 24.5C42.5 22.1362 42.0344 19.7956 41.1298 17.6117C40.2252 15.4278 38.8994 13.4435 37.2279 11.7721C35.5565 10.1006 33.5722 8.77475 31.3883 7.87017C29.2044 6.96558 26.8638 6.5 24.5 6.5Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4994 16.5L26.8594 22.14",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5005 12.5H24.4805C17.8405 12.5 12.4805 17.86 12.4805 24.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9605 13.02C26.8205 12.66 25.6605 12.48 24.4805 12.48",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard2);
export default __webpack_public_path__ + "static/media/dashboard2.42dc33e156a6d267b03c5036492aed23.svg";
export { ForwardRef as ReactComponent };